var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcErrorAlertCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12C9.81371 12 12.5 9.31371 12.5 6C12.5 2.68629 9.81371 0 6.5 0C3.18629 0 0.5 2.68629 0.5 6C0.5 9.31371 3.18629 12 6.5 12Z",
    fill: "#FA1C44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77567 8.23986C5.77666 8.09372 5.8209 7.95114 5.90281 7.83011C5.98472 7.70908 6.10064 7.61501 6.23594 7.55977C6.37124 7.50453 6.51988 7.49058 6.66309 7.51969C6.80631 7.54881 6.93769 7.61968 7.04069 7.72337C7.14368 7.82705 7.21365 7.95892 7.2418 8.10233C7.26995 8.24573 7.25501 8.39426 7.19886 8.52919C7.14271 8.66412 7.04786 8.7794 6.92628 8.86049C6.80469 8.94158 6.66181 8.98486 6.51566 8.98486C6.41749 8.98693 6.31993 8.96904 6.22889 8.93227C6.13784 8.89549 6.05523 8.84061 5.98603 8.77094C5.91683 8.70128 5.86249 8.61828 5.82633 8.52699C5.79017 8.4357 5.77294 8.33801 5.77567 8.23986ZM5.95566 4.06486L5.91569 2.98486H7.11066L7.07068 4.06486L6.90067 6.92486H6.12568L5.95566 4.06486Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcErrorAlertCircle);
export default __webpack_public_path__ + "static/media/ic_error_alert_circle.30399508bac2a3feb40d5974fbac2f48.svg";
export { ForwardRef as ReactComponent };